
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { SignupComponent } from './signup/signup.component';
import { HomeComponent } from './home/home.component';
import { RoleGuardService as RoleGuard } from './services/role-guard.service'
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { SubscriptionPricingComponent } from './subscription-pricing/subscription-pricing.component';
import { MyPortfolioProComponent } from './my-portfolio-pro/my-portfolio-pro.component';
import { AboutComponent } from './about/about.component';
import { EmailVerificationComponent } from './email-verification/email-verification.component';
import { RestoreAccountComponent } from './restore-account/restore-account.component';
import { CompleteRestoreComponent } from './complete-restore/complete-restore.component';
const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'admin', canActivate: [RoleGuard], data: { expectedRole: ['admin'] }, loadChildren: './admin/admin.module#AdminModule' },
  { path: 'user', canActivate: [RoleGuard], data: { expectedRole: ['user'] }, loadChildren: './components/components.module#ComponentsModule' },
  { path: 'csv', canActivate: [RoleGuard], data: { expectedRole: ['user'] }, loadChildren: './csv/csv.module#CsvModule' },
  { path: 'help', loadChildren: './help/help.module#HelpModule' },
  { path: 'newsletter', loadChildren: './newsletter/newsletter.module#NewsletterModule' },
  { path: 'login', component: LoginComponent },
  { path: 'signup', component: SignupComponent },
  { path: 'home', component: HomeComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'change-password', component: ChangePasswordComponent },
  { path: 'page-not-found', component: PageNotFoundComponent },
  { path: 'pricing', component: SubscriptionPricingComponent },
  { path: 'my-portfolio-pro', component: MyPortfolioProComponent },
  { path: 'about', component: AboutComponent },
  { path: 'complete-signup', component: EmailVerificationComponent },
  { path: 'restore-account', component: RestoreAccountComponent },
  { path: 'restore-verification', component: CompleteRestoreComponent },
  {
    path: '**',
    redirectTo: 'page-not-found',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]

})
export class AppRoutingModule { }
